import Helpers from './helpers';
import Ping from './ping';

const CommunicationPreferences = {
	init({ element }) {
		this.urlBase = '/umbraco/api/professionalApi/';
		this.apiEndpointGet = element?.dataset?.apiEndpointGet;
		this.apiEndpointSet = element?.dataset?.apiEndpointSet;
		this.templateId = element.dataset.templateId;
		this.preference = true;
		this.getCommunicationPreference();
	},

	async getCommunicationPreference() {
		await fetch(`${this.urlBase}${this.apiEndpointGet}`, {
			headers: { 'Content-Type': 'application/json', Culture: document.documentElement.lang },
			method: 'GET',
		})
			.then((response) => {
				if (response.ok) {
					return response.json();
				}
				return false;
			})
			.then((data) => {
				if (!data.communicationPreference) {
					this.cookieKey = data?.cookieKey;
					this.cookieValue = data?.cookieValue;
					this.cookieExpiration = data?.cookieExpiration;
					this.renderPopUp();
				}
			});
	},

	renderPopUp() {
		if (!document.cookie.includes(this.cookieValue)) {
			window.dispatchEvent(
				new CustomEvent('lightbox-show-by-template-id', {
					detail: {
						templateId: `${this.templateId}`,
					},
				})
			);
			this.renderActions();
		}
	},

	async setCommunicationPreference() {
		await fetch(`${this.urlBase}${this.apiEndpointSet}?preference=${this.preference}`, {
			headers: { 'Content-Type': 'application/json', Culture: document.documentElement.lang },
			method: 'POST',
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error();
				}
				return response.json();
			})
			.then((data) => {
				if (data != null) {
					Ping.createHappyPing(
						data?.ping?.pingHeading,
						data?.ping?.pingBody,
						data?.ping?.pingEmotion
					);
				}
			})
			.catch((data) => {
				if (data != null) {
					Ping.createSadPing(
						data?.ping?.pingHeading,
						data?.ping?.pingBody,
						data?.ping?.pingEmotion
					);
				}
			});
	},

	renderActions() {
		document.querySelector('.lightbox__close').addEventListener('click', () => {
			Helpers.setCookie(this.cookieKey, this.cookieValue, this.cookieExpiration);
		});
		document.getElementById('popupSubmit').addEventListener('click', () => {
			this.setCommunicationPreference();
			document.querySelector('.lightbox__container').classList.remove('is-open');
		});
	},
};

export { CommunicationPreferences as default };
